import { node } from "prop-types";
import React from "react";

const CardPriceAction = ({ children }) => {
	return <div className="card-price__action">{children}</div>;
};

CardPriceAction.propTypes = {
	children: node.isRequired,
};

export default CardPriceAction;
